import { render, staticRenderFns } from "./ProductChangeLogsPanel.vue?vue&type=template&id=217ca7e2&scoped=true"
import script from "./ProductChangeLogsPanel.vue?vue&type=script&lang=js"
export * from "./ProductChangeLogsPanel.vue?vue&type=script&lang=js"
import style0 from "./ProductChangeLogsPanel.vue?vue&type=style&index=0&id=217ca7e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ca7e2",
  null
  
)

export default component.exports